import { Dispatch, SetStateAction } from 'react';
import { projectsOrderedByNameUrl } from 'router/url';
import { Data } from 'components/Dialog/types';
import { ProjectDataProps } from 'modules/ManagerForm/types';
import { getFetch } from './fetchFunctions';

export interface ProjectOption extends Data {
  projectName: string;
  clientId?: number;
  clientName: string;
}

export const fetchAllProjects = async (
  setProjectData: Dispatch<SetStateAction<ProjectOption[]>>,
) => {
  const projectsResponse = await getFetch({
    url: projectsOrderedByNameUrl,
  });
  if (projectsResponse) {
    const projectData = projectsResponse.map(
      ({ id: value, projectName: name, client }: ProjectDataProps) => ({
        value,
        name: `${name} (${client.clientName})`,
        projectName: name,
        clientId: (client as { id?: number }).id,
        clientName: client.clientName,
      }),
    );
    setProjectData(projectData);
  }
};
